/*
 * NEGOTIA Utility Engine - product fit block (tool #2, product-fit-block).
 * Uses UGE.fitLaptop / UGE.clearance from uge-core.js (FIT-LAPTOP v1). No rule logic lives here.
 */
(function () {
  'use strict';
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return (s || '').toLowerCase().replace(/[^a-z0-9.]+/g, ' ').trim(); }
  function fmt(n) { return (Math.round(n * 10) / 10).toLocaleString(document.documentElement.lang || 'en'); }
  var GOOD = { excellent: 1, fits: 1, snug: 1 };

  function init(root) {
    var U = window.UGE;
    var dataEl = root.querySelector('script[data-uge-data]');
    if (!U || !U.fitLaptop || !dataEl) return;
    var data = JSON.parse(dataEl.textContent), L = data.labels;
    var cur = root.getAttribute('data-uge-current');
    var seen = {}, prods = [];
    data.products.forEach(function (p) { if (!seen[p.title]) { seen[p.title] = 1; prods.push(p); } });
    var me = prods.filter(function (p) { return p.title === cur; })[0];
    if (!me) return;
    var others = prods.filter(function (p) { return p !== me; });
    var devices = data.devices.filter(function (d) { return d.cat === 'laptop'; }).sort(function (a, b) { return a.pop - b.pop; });
    var input = root.querySelector('[data-uge-search]');
    var list = root.querySelector('[data-uge-suggest]');
    var out = root.querySelector('[data-uge-result]');
    var tool = 'product-fit-block', lastQuery = '';

    U.track('uge_tool_view', { tool: tool, product: me.handle, rule_version: U.FIT_LAPTOP_VERSION });

    function score(d, q) {
      var hay = norm(d.name + ' ' + d.brand + ' ' + d.family + ' ' + (d.aliases || []).join(' ') + ' ' + (d.gens || []).join(' '));
      var parts = q.split(' ').filter(Boolean), s = 0;
      for (var i = 0; i < parts.length; i++) { if (hay.indexOf(parts[i]) === -1) return -1; s += 1; }
      return s * 100 - d.pop;
    }
    function suggest(q) {
      q = norm(q);
      if (!q) { list.hidden = true; list.innerHTML = ''; return; }
      var hits = devices.map(function (d) { return [score(d, q), d]; }).filter(function (x) { return x[0] >= 0; })
        .sort(function (a, b) { return b[0] - a[0]; }).slice(0, 8);
      if (!hits.length) {
        list.innerHTML = '<li class="uge-suggest__empty">' + esc(L.no_device) + '</li>';
        list.hidden = false;
        if (q.length > 3 && q !== lastQuery) { lastQuery = q; U.track('uge_no_result', { tool: tool, term: q }); }
        return;
      }
      list.innerHTML = hits.map(function (x) { return '<li><button type="button" data-h="' + esc(x[1].h) + '">' + esc(x[1].name) + '</button></li>'; }).join('');
      list.hidden = false;
    }
    function label(c) { return L['c_' + c] || L.c_fits; }
    function render(d) {
      list.hidden = true;
      input.value = d.name;
      var c = U.fitLaptop(d, me);
      U.track('uge_query', { tool: tool, term: d.h, product: me.handle, rule_version: U.FIT_LAPTOP_VERSION });
      U.track('uge_result', { tool: tool, device: d.h, product: me.handle, result: c, rule_version: U.FIT_LAPTOP_VERSION });
      var html = '<p class="uge-pdp__answer">' + esc(L.answer.replace('{device}', d.name).replace('{w}', fmt(d.w)).replace('{d}', fmt(d.d)).replace('{t}', fmt(d.t))) +
        ' <span class="uge-badge uge-badge--' + c + '">' + esc(label(c)) + '</span></p>';
      if (GOOD[c]) {
        var cl = U.clearance(d, me);
        html += '<p class="uge-pdp__meta">' + esc(L.clearance.replace('{mm}', Math.min(cl.long, cl.short))) + '</p>';
      } else if (c !== 'unknown') {
        var alts = others.map(function (p) { return { p: p, c: U.fitLaptop(d, p) }; })
          .filter(function (r) { return GOOD[r.c]; })
          .sort(function (a, b) { return (U.CLASS_ORDER[a.c] - U.CLASS_ORDER[b.c]) || (a.p.price - b.p.price); }).slice(0, 3);
        if (alts.length) {
          html += '<p class="uge-pdp__meta">' + esc(L.alt.replace('{device}', d.name)) + '</p><ul class="uge-pdp__alts">' +
            alts.map(function (r) {
              return '<li><a href="' + esc(r.p.url) + '" data-uge-product="' + esc(r.p.handle) + '">' + esc(r.p.title) + '</a> <span class="uge-badge uge-badge--' + r.c + '">' + esc(label(r.c)) + '</span> <span class="uge-pdp__price">' + esc(r.p.price_f) + (r.p.avail ? '' : ' · ' + esc(L.sold_out)) + '</span></li>';
            }).join('') + '</ul>';
        }
      }
      out.innerHTML = html;
      out.hidden = false;
    }
    input.addEventListener('input', function () { suggest(input.value); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { var b = list.querySelector('button'); if (b) { e.preventDefault(); b.click(); } } });
    list.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-h]'); if (!b) return;
      var d = devices.filter(function (x) { return x.h === b.getAttribute('data-h'); })[0];
      if (d) render(d);
    });
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-uge-product]');
      if (a) U.track('uge_product_click', { tool: tool, product: a.getAttribute('data-uge-product'), from: me.handle, rule_version: U.FIT_LAPTOP_VERSION });
      var q = e.target.closest('[data-uge-quick]');
      if (q) { var d = devices.filter(function (x) { return x.h === q.getAttribute('data-uge-quick'); })[0]; if (d) render(d); }
    });
  }
  function boot() { document.querySelectorAll('[data-uge-pfit]:not([data-uge-ready])').forEach(function (el) { el.setAttribute('data-uge-ready', ''); init(el); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
